import { render, staticRenderFns } from "./withdrawCard.vue?vue&type=template&id=7b532a8a&scoped=true"
import script from "./withdrawCard.vue?vue&type=script&lang=js"
export * from "./withdrawCard.vue?vue&type=script&lang=js"
import style0 from "./withdrawCard.vue?vue&type=style&index=0&id=7b532a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b532a8a",
  null
  
)

export default component.exports